"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Notification = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _icon = _interopRequireDefault(require("../icon"));
var _notificationModule = _interopRequireDefault(require("./notification.module.scss"));
require("../style/animations.scss");
require("../style/fonts.css");
var _utilities = require("../utilities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Notification = exports.Notification = /*#__PURE__*/function (_Component) {
  function Notification() {
    var _this;
    _classCallCheck(this, Notification);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Notification, [].concat(args));
    _defineProperty(_this, "notificationTimeout", void 0);
    _defineProperty(_this, "state", {
      visible: false
    });
    _defineProperty(_this, "nodeRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "onExit", function () {
      clearTimeout(_this.notificationTimeout);
      _this.props.onClose && _this.props.onClose();
    });
    _defineProperty(_this, "close", function () {
      _this.setVisibility(false);
    });
    return _this;
  }
  _inherits(Notification, _Component);
  return _createClass(Notification, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setVisibility(this.props.visible);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.visible !== this.props.visible) {
        this.setVisibility(this.props.visible);
      }
      this.autoHide();
    }
  }, {
    key: "setVisibility",
    value: function setVisibility(visible) {
      this.setState({
        visible: visible
      });
    }
  }, {
    key: "shouldAutoHide",
    value: function shouldAutoHide() {
      return this.props.autoHide && this.props.canClose && this.state.visible;
    }
  }, {
    key: "autoHide",
    value: function autoHide() {
      var _this2 = this;
      if (this.shouldAutoHide()) {
        this.notificationTimeout = setTimeout(function () {
          _this2.close();
        }, 5000);
      }
    }
  }, {
    key: "getTransition",
    value: function getTransition() {
      if (this.props.animate) {
        return {
          timeout: 200,
          transitionClassName: "transition-fade-scale"
        };
      } else {
        return {
          timeout: 0,
          transitionClassName: "non-transition"
        };
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return "".concat(_notificationModule["default"].notification, " ").concat(_notificationModule["default"][this.props.colour], " ").concat(_notificationModule["default"][this.props.style]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getTransition = this.getTransition(),
        timeout = _this$getTransition.timeout,
        transitionClassName = _this$getTransition.transitionClassName;
      return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
        key: "notification",
        nodeRef: this.nodeRef,
        "in": this.state.visible,
        timeout: timeout,
        appear: true,
        classNames: transitionClassName,
        onExited: this.onExit,
        unmountOnExit: true
      }, /*#__PURE__*/_react["default"].createElement("div", _extends({
        className: this.getClass(),
        ref: this.nodeRef,
        "data-testid": "notification"
      }, _utilities.utilities.getDataAttributes(this.props), {
        "data-visible": this.state.visible
      }), this.props.canClose && /*#__PURE__*/_react["default"].createElement("div", {
        className: _notificationModule["default"].close,
        "data-testid": "notification-close",
        onClick: this.close
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        type: "Close"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _notificationModule["default"].inner
      }, this.props.children)));
    }
  }]);
}(_react.Component);
Notification.propTypes = {
  colour: _propTypes["default"].oneOf(["Blue", "LightBlue", "Pink", "Red", "Orange", "Green", "Grey", "LightGrey", "DarkGrey"]),
  style: _propTypes["default"].oneOf(["Solid", "Outline"]),
  text: _propTypes["default"].string,
  visible: _propTypes["default"].bool,
  animate: _propTypes["default"].bool,
  canClose: _propTypes["default"].bool,
  autoHide: _propTypes["default"].bool,
  onClose: _propTypes["default"].func
};
Notification.defaultProps = {
  colour: "Grey",
  style: "Solid",
  text: "This is a notification",
  visible: false,
  animate: true,
  canClose: true,
  autoHide: false,
  onClose: null
};
var _default = exports["default"] = Notification;